import { render, staticRenderFns } from "./DocumentPreviewModal.vue?vue&type=template&id=65c01937&scoped=true"
import script from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewModal.vue?vue&type=style&index=0&id=65c01937&prod&lang=css"
import style1 from "./DocumentPreviewModal.vue?vue&type=style&index=1&id=65c01937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c01937",
  null
  
)

export default component.exports